import React, {Component} from "react";
import classNames from "classnames";
import styles from "./FJMusicSearchView.module.less";
import InlineSVG from "react-inlinesvg";
import BackIcon from '../../../../../icon/music-back.svg';
import FJLocalStore from "../../../../../store/FJLocalStore";
import FJMusicItem from "./FJMusicItem";
import FJButton from 'fj-components/FJButton'
import CloseIcon from '../../../../../icon/close.svg';
import FJUtil from "../../../../../util/FJUtil";
import FJSearchCommonView from "../FJSearchCommonView";
import FJEventConstant from "../../../../../constant/FJEventConstant";

class FJMusicSearchView extends Component {

	constructor(props) {
		super(props);
		this.state = {
			activeItemIndex: -1
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.active !== this.props.active && !this.props.active) {
			this.changeActiveItem(-1);
		}

		// TODO
    // 暂时使用监听处理。之后靠组件机制进行
		window.FJEvent.subscribe(FJEventConstant.STOCK_HIDDEN, () => {
      this.changeActiveItem(-1);
    });
	}

	changeActiveItem = (index) => {
		if (index !== this.state.activeItemIndex) {
			this.setState({activeItemIndex: index});
		}
	};

	_transform = (str) => {
		let _str = str.replace(/-/g, ' ');
		return _str.replace(_str[0], _str[0].toUpperCase());
	};

	_getLabel = () => {
		let {
			filter,
			onFilterChange
		} = this.props;

		if (!filter || !onFilterChange) {
			return null;
		}

		let labels = [];
		let pushBtn = (text, onClick) => {
			labels.push(
				<FJButton key={text}
				          text={text}
				          className={styles.label}
				          textClass={styles.label_text}
				          rightIcon={CloseIcon}
				          iconClass={styles.label_icon}
				          iconClick={onClick}

				/>
			)
		};
		for (let item in filter) {
			if (filter.hasOwnProperty(item)) {
				if (item === 'duration') {
					let min = filter[item][0];
					let max = filter[item][1];
					let transTime = (time) => {
						return FJUtil.formatTime(time) + (time === 240 ? '+' : '');
					};
					if (min !== 0 || max !== 240) pushBtn(transTime(min) + ' - ' + transTime(max), () => {
						onFilterChange(item, [0, 240], {changeEnd: true});
					});
				} else {
					if (filter[item]) pushBtn(this._transform(FJLocalStore._(filter[item])), () => {
						onFilterChange(item, '')
					});
				}
			}
		}

		return labels
	}

	render() {

		let {
			active,
			collections = [],
			isCollectionMode,
			backCate,
			isOpenLeftMenu,
			keywords,
			total,
			mediaList,
			collectionName,
			addMusic,
			addTips,
			searchStatus,
			searchNextPage,
			onRetry,
		} = this.props;

		const slectedIds = mediaList
			.filter(media => collections.find(audio => audio.id === media.id))
			.map(media => media.id);

		return (
			<div
				className={classNames(styles.music_search_container, {[styles.closeLeftMenu]: !isOpenLeftMenu}, {[styles.active]: active})}>
				<div className={styles.item_box}>
					<div className={styles.list_content}>
						{
							isCollectionMode ? (
								<>
									<div className={styles.back_collection} onClick={backCate}>
										<InlineSVG src={BackIcon}/>
										<span className={styles.back_title}>{FJLocalStore._('back-to-collections')}</span>
									</div>
									<span className={styles.top_title}>{collectionName}</span>
								</>
							) : (
								<div className={styles.audio_label}>
									{this._getLabel()}
									<div className={styles.label_title}>
										<span className={styles.number}>{FJUtil.formatNumber(total)}</span>
										<span className={styles.keyword}>{keywords}</span>
										<span className={styles.type}>{FJLocalStore._('audio')}</span>
									</div>
								</div>
							)
						}
						<FJSearchCommonView keywords={keywords}
						                    onRetry={onRetry}
						                    status={searchStatus}
						                    searchNextPage={searchNextPage}
						                    className={classNames(styles.search_view,{[styles.search_view_collection]: isCollectionMode})}
						                    renderList={() => {
							                    return (
								                    <ul className={classNames(styles.ul_box, {[styles.active]: true})}>
									                    {
										                    collections.map((item, index) => {
											                    const {id, title, preview_url, thumbnail_url, duration} = item;
											                    return (
												                    <FJMusicItem key={index}
												                                 url={thumbnail_url}
												                                 duration={duration}
												                                 active={this.state.activeItemIndex === index}
												                                 id={id}
												                                 selected={slectedIds.includes(id)}
												                                 index={index}
												                                 changeActiveItem={this.changeActiveItem}
												                                 previewUrl={preview_url}
												                                 name={title}
												                                 addMusic={addMusic}
												                                 addTips={addTips}
												                    />
											                    )
										                    })
									                    }
								                    </ul>
							                    );
						                    }}/>
					</div>
				</div>
			</div>
		)
	}

}

export default FJMusicSearchView;